import locale from "localization";
import styles from "../cash-noncash.module.scss";
import { Title } from "components/commons";
import useDataTable from "hooks/useDataTable";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { sortBy } from "lodash";
import { nonSaleTransactionMapper } from "./nonsale-transactions.mapper";
import { nonSaleTransactionColumn } from "./nonsale-transactions-column";
import { initialShiftRecordFilterState } from "modules/records/shift-records/shift-records-filter.state";

const ShiftDetailsNonSaleTransactions = ({ shift }) => {
  const transactions = sortBy(
    [
      ...shift?.transactionPaymentMethod.pumpCalibration.map((item) => ({
        ...item,
        from: "calibration",
      })),
      ...shift?.transactionPaymentMethod.pumpError.map((item) => ({ ...item, from: "error" })),
      ...shift?.transactionPaymentMethod.returns.map((item) => ({ ...item, from: "return" })),
      ...shift?.transactionPaymentMethod.refund.map((item) => ({ ...item, from: "refund" })),
    ],
    "transactionItemId",
  ).reverse();

  const { table } = useDataTable({
    value: transactions,
    filter: { initialState: initialShiftRecordFilterState(), mapper: (val) => val },
    table: {
      key: "fuel",
      name: "nonSaleTransactions",
      mapper: (val) => nonSaleTransactionMapper({ val }),
      columns: nonSaleTransactionColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.nonSaleTransactions}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2 {...table} hideNoSearchResultRender tableVersion="v2" hidePagination />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default ShiftDetailsNonSaleTransactions;
